import { PrimeReactStylesFunctionType } from '../types';
import { classNames } from 'primereact/utils';

export const ContextMenuTailwindThemes = {
  contextmenu: {
    root: {
      className: classNames(
        'bg-white text-black overflow-hidden shadow-lg rounded-sm border border-fletchers-gray-110',
      ),
    },
    menu: 'list-none outline-none',
    menuitem: 'relative',
    content: ({ context }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'transition-shadow duration-200 rounded-none',
        'hover:bg-fletchers-green-50', // Hover
        {
          'bg-fletchers-green-50': context.focused || context.active,
        },
      ),
    }),
    action: {
      className: classNames(
        'cursor-pointer flex items-center no-underline overflow-hidden relative',
        'px-3 py-1.5 text-black select-none',
      ),
    },
    icon: {
      className: classNames('text-gray-600 mr-2'),
    },
    label: {
      className: classNames('text-sm text-black'),
    },
    transition: {
      timeout: { enter: 250 },
      classNames: {
        enter: 'opacity-0',
        enterActive: '!opacity-100 transition-opacity duration-250',
      },
    },
  },
};
